module.exports = __webpack_public_path__ + "media/images/gift-img-459072bc287eb14631ea3a07a406532f.png";